export default {
  DriverProfileForm: {
    label: {
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone #',
      employeeId: 'Alpha Code',
      email: 'Email',
    },
    btn: {
      save: 'Save',
    },
  },
};
